import React, { Component } from 'react';
import { getTranslation } from '../Utilities/GetTranslation.js'

class Reloading extends Component {
    render() {
        return (
            <div className="jobwizard-loading">
                <img src="/Search_Selection/assets/images/ripple.gif" alt="Loading" />
                <span>{getTranslation("SNS.JobFinder.Reloading")}</span>
            </div>
        );
    }
}

export default Reloading;


// WEBPACK FOOTER //
// ./src/Components/Reloading.js